module.exports = __webpack_public_path__ + "img/splash.04ce12a1.png";